import { FC, useState } from 'react';
import { Bar, BarChart, CartesianGrid, Cell, ResponsiveContainer, XAxis, YAxis } from 'recharts';

import { activeColors, fillColors, strokeColors } from '../../../../cap-table/graphs/index';
import { CustomYAxisTick, GraphDataItem } from './liquidity-graph-wrapper';

export const LiquidityMobileGraph: FC<{
  data: GraphDataItem[];
  stakeholderId: string;
}> = ({ data, stakeholderId }) => {
  const [activeIndex, setActiveIndex] = useState<null | number>(null);
  return (
    <ResponsiveContainer height={512} width="100%">
      <BarChart data={data} height={40} layout="vertical" width={150}>
        <XAxis
          axisLine={{ stroke: '#F2F4F7', strokeWidth: 1 }}
          tick={{ fontSize: 10, fontWeight: 500 }}
          tickFormatter={(value) => `${value.toLocaleString('en-US')}`}
          tickLine={false}
          type="number"
        />
        <YAxis
          axisLine={false}
          dataKey="label"
          tick={(props) => <CustomYAxisTick {...props} currentStakeholderId={stakeholderId} />}
          tickLine={false}
          type="category"
          width={100}
        />
        <CartesianGrid horizontal={false} stroke="#F2F4F7" strokeDasharray="0" vertical={true} />
        <Bar dataKey="liquidity" radius={[0, 4, 4, 0]}>
          {data.map((entry, index) => {
            const isActive = activeIndex === index;

            return (
              <Cell
                fill={
                  isActive
                    ? activeColors[index % activeColors.length]
                    : fillColors[index % fillColors.length]
                }
                fillOpacity={1}
                key={entry.label}
                onClick={() => setActiveIndex(index)}
                stroke={strokeColors[index % strokeColors.length]}
                style={{
                  transition: 'all 0.5s ease, stroke 0.5s ease',
                }}
              />
            );
          })}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};
